module.exports = __webpack_public_path__ + "img/1476010444.b4f5fd8d.jpg";